<template>
  <div
    style="width: 100%;"
    class="container"
  >
    <h3 class="uk-text-center title">
      Resultados de la Simulación
    </h3>
    <div
      class="uk-flex uk-flex-right uk-text-right "
      @click="downloadPdf"
    >
      <label
        class="cursor-pointer uk-margin-right"
      >
        <font-awesome-icon :icon="{ prefix: 'fa', iconName: 'download' }" /> &nbsp; <span class="uk-text-primary">Descargar Simulación</span>
      </label>
    </div>
    <loading
      :active="isLoading"
      :is-full-page="true"
    />
    <div class="gif">
      <plottly-stack-pie-chart
        v-if="items.length"
        :items="items"
        style="font-size 18px;"
        @setImage="setImage($event)"
      />
    </div>

    <section class="container-section">
      <div class="uk-text-left">
        <loading
          :active="isLoading"
          :is-full-page="true"
        />
        <section class="section-titles" />
        <section>
          <h4 class="title ">
            Hoja Resumen
          </h4>
          <div class="list-items">
            <div class="items uk-form-width-medium">
              <label style="cursor: pointer">
                Origen
                <input
                  v-model="scenarioResult.originPlace"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>

            <div class="items uk-form-width-medium">
              <label style="cursor: pointer">
                Destino
                <input
                  v-model="scenarioResult.destinationPlace"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>

            <div class="items uk-form-width-medium">
              <label style="cursor: pointer">
                Fecha
                <input
                  v-model="scenarioResult.dispatchDate"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>

            <div class="items">
              <label style="cursor: pointer">
                Incoterm
                <input
                  v-model="scenarioResult.incoterm"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>
          </div>

          <div class="list-items">
            <div class="uk-form-width-small uk-flex uk-flex-column uk-flex-center cost-title">
              Costo Total
            </div>
            <div class="items uk-form-width-medium">
              <label
                style="cursor: pointer"
              >
                Peso Dominicano
                <input
                  v-model="scenarioResult.total"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>

            <div class="items uk-form-width-medium">
              <label
                style="cursor: pointer"
              >
                Dolar Estadounidense
                <input
                  v-model="scenarioResult.totalDollars"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>

            <div class="uk-form-width-small uk-flex uk-flex-column uk-flex-center cost-title">
              Costo en RD
            </div>
            <div class="items uk-form-width-medium">
              <label style="cursor: pointer">
                Peso Dominicano
                <input
                  v-model="scenarioResult.rdTotal"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>
            <div class="items uk-form-width-medium">
              <label
                style="cursor: pointer"
              >
                Dolar Estadounidense
                <input
                  v-model="scenarioResult.rdTotalDollars"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>
          </div>
          <div class="list-items">
            <div class="data-porcent items">
              <div
                class="uk-flex uk-flex-column uk-flex-center cost-title"
                style="margin-bottom: 10px"
              >
                Porcentaje del Costo en RD
              </div>
              <label
                style="cursor: pointer"
              >
                <input
                  v-model="scenarioResult.rdCostPercent"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>
            <div class="data-porcent items">
              <div
                class="uk-flex uk-flex-column uk-flex-center cost-title"
                style="margin-bottom: 10px"
              >
                Porcentaje Sobre Valor de Venta
              </div>
              <label
                style="cursor: pointer"
              >
                <input
                  v-model="scenarioResult.saleValuePercent"
                  class="uk-input"
                  type="text"
                  readonly="readonly"
                >
              </label>
            </div>
          </div>
        </section>
      </div>
    </section>
    <div class="uk-margin btn">
      <button
        class="uk-button btn-success"
        :disabled="disableBackButton"
        @click="backPage"
      >
        Atrás
      </button>
      <button
        class="uk-button btn-success"
        @click="goHome"
      >
        Salir
      </button>
    </div>
  </div>
</template>

<script>
import PlottlyStackPieChart from '../../PlottlyStackPieChart'
import moment from 'moment'
import { mapState, mapMutations } from 'vuex'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
export default {
  components: {
    PlottlyStackPieChart
  },
  data () {
    return {
      graphicImage: null,
      items: [],
      isLoading: true,
      scenarioResult: {}
    }
  },
  computed: {
    ...mapState([
      'transportChainScenario'
    ])
  },
  async mounted () {
    this.isLoading = true
    try {
      if (!this.transportChainScenario) {
        this.$router.push({ name: 'Home' })
      }
      this.setShowResult(true)
      this.scenarioResult = await this.$services.transportChainScenarioService.calculate(this.transportChainScenario)
      const formatter = new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' })
      const formatterUsd = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' })
      this.scenarioResult.totalDollars = formatterUsd.format(parseFloat(this.scenarioResult.totalDollars.toFixed(2)))
      this.scenarioResult.rdTotalDollars = formatterUsd.format(parseFloat(this.scenarioResult.rdTotalDollars.toFixed(2)))
      this.scenarioResult.total = formatter.format(parseFloat(this.scenarioResult.total.toFixed(2)))
      this.scenarioResult.rdTotal = formatter.format(parseFloat(this.scenarioResult.rdTotal.toFixed(2)))
      this.scenarioResult.rdCostPercent = parseFloat(this.scenarioResult.rdCostPercent.toFixed(2)) + '%'
      this.scenarioResult.saleValuePercent = parseFloat(this.scenarioResult.saleValuePercent.toFixed(2)) + '%'
      this.scenarioResult.dispatchDate = moment(this.scenarioResult.dispatchDate).format('YYYY-MM-DD')
      this.items = this.scenarioResult.groupsComponents.map((item) => {
        return {
          originPlace: item.costComponentOriginPlace,
          group: String.fromCharCode(item.costComponentTypePosition),
          value: item.subTotal,
          color: item.costComponentTypeColor,
          text: formatter.format(item.subTotal),
          name: item.costComponentTypeDescription
        }
      }).sort((a, b) => (a.group > b.group) ? 1 : -1)
      this.isLoading = false
    } catch (e) {
      this.isLoading = false
    }
  },
  beforeUnmount () {
    this.setShowResult(false)
  },
  methods: {
    ...mapMutations([
      'setShowResult'
    ]),
    goHome () {
      this.$router.push({ name: 'Home' })
      this.$windowPlugin.scrollToTop()
    },
    backPage () {
      this.$store.commit('backPage')
      this.$windowPlugin.scrollToTop()
    },
    downloadPdf () {
      const totalPdf = this.scenarioResult.total.toString()
      const totalDollarsPdf = this.scenarioResult.totalDollars.toString()
      const rdTotalPdf = this.scenarioResult.rdTotal.toString()
      const rdTotalDollarsPdf = this.scenarioResult.rdTotalDollars.toString()
      const rdCostPercentPdf = this.scenarioResult.rdCostPercent.toString()
      const saleValuePercentsPdf = this.scenarioResult.saleValuePercent.toString()
      const imgData = this.graphicImage
      const doc = new jsPDF() //eslint-disable-line
      doc.addImage('../../../assets/img/only-logo.jpg', 'JPEG', 83, 2, 33, 14)
      doc.addImage('../../../assets/img/logo-cost.png', 'png', 5, 1, 29, 18)
      doc.addImage('../../../assets/img/header-logo-observatory-national.jpg', 'JPEG', 164, 1, 40, 17)
      doc.line(6, 19, 204, 19)

      doc.setFontSize(14)
      doc.setTextColor(100)
      doc.setFont('helvetica', 'bold')
      doc.text(' Resultados de la Simulación', 74, 28)
      const size = 200
      doc.addImage(imgData, 'JPEG', 0, 35, size, size)
      doc.addPage()
      doc.setFontSize(12)
      doc.setDrawColor(0)
      doc.setFillColor(63, 128, 187)
      doc.rect(25, 28, 150, 10, 'F')
      doc.rect(25, 58, 150, 10, 'F')
      doc.rect(25, 108, 150, 10, 'F')
      doc.rect(25, 153, 150, 10, 'F')
      doc.rect(22, 194, 163, 10, 'F')
      doc.setTextColor(23, 32, 42)
      doc.text(35, 35, 'Origen:')
      doc.text(120, 35, 'Destino')
      doc.text(35, 65, 'Fecha')
      doc.text(120, 65, 'Incoterm')
      doc.setFontSize(13)
      doc.text(35, 105, 'Costo Total')
      doc.setFontSize(12)
      doc.text(35, 115, 'RD')
      doc.text(120, 115, 'USA')
      doc.text(35, 150, ' Costo en RD')
      doc.text(35, 160, 'RD')
      doc.text(120, 160, 'USA')
      doc.text(35, 200, 'Porcentaje del Costo en RD')
      doc.text(115, 200, 'Porcentaje Sobre Valor de Venta')
      doc.setTextColor(100, 100, 100)
      doc.setDrawColor(0)
      doc.setFontSize(9)
      doc.setFillColor(245, 245, 245)
      doc.text(35, 45, this.scenarioResult.originPlace)
      doc.text(120, 45, this.scenarioResult.destinationPlace)
      doc.text(35, 75, this.scenarioResult.dispatchDate)
      doc.text(120, 75, this.scenarioResult.incoterm)
      doc.text(35, 125, totalPdf)
      doc.text(120, 125, totalDollarsPdf)
      doc.text(35, 175, rdTotalPdf)
      doc.text(120, 175, rdTotalDollarsPdf)
      doc.text(35, 210, rdCostPercentPdf)
      doc.text(120, 210, saleValuePercentsPdf)

      doc.save('Idb.pdf')
    },
    setImage (image) {
      this.graphicImage = image
    }
  }
}
</script>
<style scoped>
.container{
  margin: 10px 0px;
}

.container-section{
  padding: 10px 0px 10px 40px
}
.cost-title{
    font-weight: 600;
    width: 100%;
    margin-bottom: 20px;
}
.uk-padding{
  padding-top: 5px;
  padding-right: 5px;
}

.title-porcent{
  width: 240px !important;
}

.title{
  font-weight: 600;
  margin: 14px 0px;

}

.list-items .items{
  width: 10%;
  min-width: 200px;
  margin-right: 20px;
  flex-grow: 1
}
.list-items{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px;
  justify-content: space-between;
}
.list-items-2{
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 30px ;
}

.items{
  margin: 0px 0px 20px;
}

.items-cost{
  margin: 10px 0px 35px 0px
}
.gif{
  margin-top: 15px
}
.btn{
  display: flex;
  justify-content: space-around;
}
.btn button{
  width: 80px
}

@media screen and (max-width: 879px){
  .cost-title{
    font-weight: 600;
    width: 100%;
    margin-bottom: 10px;
  }

  .container-section{
    padding: 10px 20px;
  }

  .title{
    font-size: 17px;
  }

.title-porcent{
  width: 180px !important;
}

  *{
    font-size: 12px;
  }
}

@media screen and (max-width: 689px){
  .title{
    font-size: 13px;
  }
  *{
    font-size: 10px;
  }
  .label-item{
    margin-right: 12px
  }

.title-porcent{
  width: 150px !important;
  margin-bottom: 3px;
}

}
</style>
